import { render, staticRenderFns } from "./intake-variety-size.vue?vue&type=template&id=1139fc44"
import script from "./intake-variety-size.vue?vue&type=script&lang=js"
export * from "./intake-variety-size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports